module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/289.0fb6702a.png";